import { render, staticRenderFns } from "./NotificationsView.vue?vue&type=template&id=5c4ec241&scoped=true"
import script from "./NotificationsView.vue?vue&type=script&lang=js"
export * from "./NotificationsView.vue?vue&type=script&lang=js"
import style0 from "./NotificationsView.vue?vue&type=style&index=0&id=5c4ec241&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4ec241",
  null
  
)

export default component.exports